var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAir = function SvgIconAir(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 104,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-air_svg__a)",
    d: "m66.873 60.672-.036.01c-.182.046-.364.093-.531.152l-.155.04c-.11.028-.228.058-.325.091-.495.169-.973.333-1.412.52-1.188.505-1.72 1.764-1.287 2.944l.33.896c.395 1.072 1.573 1.784 2.788 1.675a16 16 0 0 0 1.71-.253c.114-.012.223-.04.342-.07l.154-.04q.274-.067.552-.124l.037-.01c2.047-.498 4.103-1.216 4.935-2.2l-1.522-4.136c-1.351-.425-3.537-.059-5.567.485z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EEEEEF",
    d: "M73.976 62.057c.42 1.141.379 2.166-.104 2.29-.482.123-1.206-.706-1.626-1.847s-.378-2.166.104-2.29c.482-.123 1.206.706 1.626 1.847"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#DBDCDC",
    d: "M73.738 62.143c.267.728.245 1.37-.046 1.445s-.745-.455-1.01-1.175-.245-1.37.046-1.445.745.455 1.01 1.175"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#EEEEEF",
    d: "m64.69 44.187-11.45-6.541-4.881-3.98 2.157-.552 6.509 2.91 25.14 3.695z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-air_svg__b)",
    d: "M104.448 37.223c-4.05-2.048-8.443-4-16.762-1.873S52.333 44.49 40.11 47.615s-21.374 4.643-26.126 5.775c.26.813.394 1.231.531 1.632 4.76-.463 11-1.254 18.004-2.626 15.537-3.05 50.073-12.627 54.211-13.559 4.13-.93 12.947 4.089 15.797 6.988.97.984 1.754 2.032 2.414 3.07l1.593-.407c7.1-1.815 1.972-9.227-2.066-11.27z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-air_svg__c)",
    fillOpacity: 0.3,
    d: "M104.448 37.223c-4.05-2.048-8.443-4-16.762-1.873S52.333 44.49 40.11 47.615s-21.374 4.643-26.126 5.775c.26.813.394 1.231.531 1.632 4.76-.463 11-1.254 18.004-2.626 15.537-3.05 50.073-12.627 54.211-13.559 4.13-.93 12.947 4.089 15.797 6.988.97.984 1.754 2.032 2.414 3.07l1.593-.407c7.1-1.815 1.972-9.227-2.066-11.27z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-air_svg__d)",
    fillOpacity: 0.4,
    d: "M104.448 37.223c-4.05-2.048-8.443-4-16.762-1.873S52.333 44.49 40.11 47.615s-21.374 4.643-26.126 5.775c.26.813.394 1.231.531 1.632 4.76-.463 11-1.254 18.004-2.626 15.537-3.05 50.073-12.627 54.211-13.559 4.13-.93 12.947 4.089 15.797 6.988.97.984 1.754 2.032 2.414 3.07l1.593-.407c7.1-1.815 1.972-9.227-2.066-11.27z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-air_svg__e)",
    d: "M86.72 38.84c-4.13.93-38.665 10.505-54.211 13.558a188 188 0 0 1-18.004 2.626c.16.437.885 2.405 1.197 3.28 5.356 2.108 20.119 7.585 30.476 4.936 28.289-7.232 36.56-8.652 58.747-14.333a18 18 0 0 0-2.415-3.07c-2.852-2.907-11.667-7.918-15.796-6.988z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-air_svg__f)",
    fillOpacity: 0.2,
    d: "M86.72 38.84c-4.13.93-38.665 10.505-54.211 13.558a188 188 0 0 1-18.004 2.626c.16.437.885 2.405 1.197 3.28 5.356 2.108 20.119 7.585 30.476 4.936 28.289-7.232 36.56-8.652 58.747-14.333a18 18 0 0 0-2.415-3.07c-2.852-2.907-11.667-7.918-15.796-6.988z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-air_svg__g)",
    fillOpacity: 0.2,
    d: "M86.72 38.84c-4.13.93-38.665 10.505-54.211 13.558a188 188 0 0 1-18.004 2.626c.16.437.885 2.405 1.197 3.28 5.356 2.108 20.119 7.585 30.476 4.936 28.289-7.232 36.56-8.652 58.747-14.333a18 18 0 0 0-2.415-3.07c-2.852-2.907-11.667-7.918-15.796-6.988z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-air_svg__h)",
    fillOpacity: 0.2,
    d: "M86.72 38.84c-4.13.93-38.665 10.505-54.211 13.558a188 188 0 0 1-18.004 2.626c.16.437.885 2.405 1.197 3.28 5.356 2.108 20.119 7.585 30.476 4.936 28.289-7.232 36.56-8.652 58.747-14.333a18 18 0 0 0-2.415-3.07c-2.852-2.907-11.667-7.918-15.796-6.988z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-air_svg__i)",
    d: "M102.814 49.07c-7.31 2.078-50.83 12.786-61.379 14.511-.91.15-2.597.195-3.86.116-8.117-.489-21.875-5.4-21.875-5.4l.262.712s12.8 5.366 22.267 5.954c1.62.097 2.202.057 4.549-.359 12.318-2.22 36.258-7.603 42.392-9.171l18.613-4.76c3.422-.874 5.858-2.536 6.512-3.843.461-.914-.23-1.34-.23-1.34s.058 1.493-7.263 3.574z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-air_svg__j)",
    d: "m92.019 39.302.419.949c.028.077.087.129.164.176.458.243 2.183 1.034 4.402.676.263-.042.39-.293.268-.488l-1.51-2.454c-.096-.151-.302-.224-.5-.166-.845.275-1.867.553-2.985.873-.218.055-.332.26-.255.442z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-air_svg__k)",
    d: "m79.261 43.602.493 1.089c.052.117.087.232.212.207.232-.048.758-.166 1.894-.435a.2.2 0 0 0 .144-.272l-.459-1.186a.247.247 0 0 0-.302-.143c-.736.25-.71.268-1.917.614a.095.095 0 0 0-.065.126"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-air_svg__l)",
    d: "m82.549 42.762.492 1.088c.053.117.087.233.212.207.232-.047.758-.165 1.894-.435a.2.2 0 0 0 .144-.27l-.459-1.187a.247.247 0 0 0-.301-.143c-.737.25-.71.268-1.918.614a.095.095 0 0 0-.064.126"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-air_svg__m)",
    d: "m85.835 41.921.492 1.09c.053.116.087.231.212.206.233-.048.759-.166 1.894-.435a.2.2 0 0 0 .144-.271l-.458-1.186a.247.247 0 0 0-.302-.143c-.737.25-.71.268-1.918.614a.095.095 0 0 0-.064.125"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-air_svg__n)",
    d: "M105.001 38.128c.253-.123.264-.42.029-.569-.51-.33-1.284-.81-1.555-.951-.75-.387-1.939-.778-2.438-.944a.46.46 0 0 0-.397.06c-.334.228-1.258.774-3.443 1.576-.228.083-.321.317-.194.502l1.862 2.515c.102.142.303.2.485.153 2.104-.614 4.585-1.801 5.644-2.332z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-air_svg__o)",
    d: "M61.202 56.03a13.6 13.6 0 0 0-4.76 2.248l-1.217.915L45 73.128l-5.952-3.59-2.538 1.06 8.883 6.116 5.134-1.312s20.796-15.306 30.687-21.764c.62-.402 2.338-1.738 2.338-1.738.796-.463.171-1.619-.748-1.384L61.204 56.04z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-air_svg__p)",
    d: "m48.359 33.665 4.88 3.98 3.786-1.62-6.509-2.911z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-air_svg__q)",
    d: "m36.506 70.59 2.532-1.05 11.476 5.856-5.125 1.31z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-air_svg__r)",
    d: "m12.508 65.858 13.584-8.116a6.3 6.3 0 0 1 1.318-.504l4.769-1.22c.51-.13 1.141.287 1.503.999.433.853.312 1.797-.273 2.047 0 0-12.046 5.879-16.406 6.994-2.594.663-4.492-.193-4.492-.193z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-air_svg__s)",
    d: "M19.277 53.108 8.571 41.634l3.568-.912 13.603 6.142 10.566 2.435z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-air_svg__paint19_radial_116_1760)",
    fillOpacity: 0.1,
    d: "M60.052 89.009c19.911 0 36.053-.994 36.053-2.219s-16.142-2.219-36.053-2.219S24 85.565 24 86.79s16.141 2.219 36.052 2.219",
    style: {
      mixBlendMode: "multiply"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-air_svg__a",
    x1: 78.825,
    x2: 77.445,
    y1: 61.076,
    y2: 56.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33A1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#2FE8AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-air_svg__b",
    x1: 82.664,
    x2: 95.305,
    y1: 44.934,
    y2: 21.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    stopColor: "#EDEDF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.858,
    stopColor: "#C8C9D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9A9B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFAFBD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-air_svg__c",
    x1: 34.577,
    x2: 63.684,
    y1: 34.541,
    y2: 53.492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2A2A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEE0FF",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-air_svg__d",
    x1: 84.337,
    x2: 74.474,
    y1: 36.028,
    y2: 42.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEEEF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-air_svg__e",
    x1: 53.979,
    x2: 51.494,
    y1: 55.382,
    y2: 83.517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9A9B7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-air_svg__f",
    x1: 107.563,
    x2: 35.841,
    y1: 31.449,
    y2: 67.579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#535777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.153,
    stopColor: "#454F99",
    stopOpacity: 0.588
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#888DB8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-air_svg__g",
    x1: 183.065,
    x2: 93.506,
    y1: 75.76,
    y2: 43.872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.698,
    stopColor: "#2F3140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-air_svg__h",
    x1: 63.907,
    x2: 60.811,
    y1: 63.52,
    y2: 51.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F3140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-air_svg__i",
    x1: 161.767,
    x2: 53.368,
    y1: 36.713,
    y2: 80.109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CED4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#32B9E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-air_svg__j",
    x1: 93.288,
    x2: 94.531,
    y1: 32.722,
    y2: 41.126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F3140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515571"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-air_svg__k",
    x1: 79.991,
    x2: 80.637,
    y1: 40.274,
    y2: 44.481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F3140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515571"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-air_svg__l",
    x1: 83.278,
    x2: 83.924,
    y1: 39.433,
    y2: 43.641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F3140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515571"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-air_svg__m",
    x1: 86.564,
    x2: 87.21,
    y1: 38.593,
    y2: 42.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F3140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515571"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-air_svg__n",
    x1: 99.967,
    x2: 101.822,
    y1: 28.645,
    y2: 39.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F3140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515571"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-air_svg__o",
    x1: 80.522,
    x2: 88.343,
    y1: 52.154,
    y2: 107.565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515571"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-air_svg__p",
    x1: 54.103,
    x2: 50.945,
    y1: 34.146,
    y2: 35.417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CED4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#32B9E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-air_svg__q",
    x1: 45.46,
    x2: 40.498,
    y1: 71.175,
    y2: 73.161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CED4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#32B9E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-air_svg__r",
    x1: 29.575,
    x2: 28,
    y1: 57.172,
    y2: 96.029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515571"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-air_svg__s",
    x1: 26.682,
    x2: 16.612,
    y1: 42.505,
    y2: 46.605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CED4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#32B9E8"
  })))));
};
export default SvgIconAir;